import * as PropTypes from 'prop-types';
/**
 * Represents the columns of the KendoReact ExcelExport component.
 * @returns null
 */

var ExcelExportColumn = function ExcelExportColumn(_) {
  return null;
};

ExcelExportColumn.propTypes = {
  cellOptions: PropTypes.any,
  field: PropTypes.string,
  footerCellOptions: PropTypes.any,
  footer: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  groupFooterCellOptions: PropTypes.any,
  groupFooter: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  groupHeaderCellOptions: PropTypes.any,
  groupHeader: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  headerCellOptions: PropTypes.any,
  hidden: PropTypes.bool,
  level: PropTypes.number,
  locked: PropTypes.bool,
  title: PropTypes.string,
  width: PropTypes.number
};
export default ExcelExportColumn;